//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'DO2',
  data() {
    return {
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
      },
      hasScore: false,
      disabled: false,
      text: '',
      num1: null,
      num2: null,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        let res1 = [1.34 * (form.item2 * 10) * form.item3 + 0.003 * form.item4] / 1000
        let res2 = 10 * form.item1 * res1
        self.num1 = res1.toFixed(1)
        self.num2 = res2.toFixed(1)
        self.hasScore = true
        return String(res1.toFixed(1), res2.toFixed(1))
      }
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/DO2.vue